import { IPieChartData } from '../../../shared/interfaces/shared/IChart';
import { IDashboardData } from '../../../shared/interfaces/user/IUser';
import { requests } from '../../../utils/api/api.service';
import { USER_URL } from '../../../utils/api/endpoints';

export const AdminDashboardService = {
  getAll: (): Promise<{
    cards: IDashboardData;
    charts: {
      expensePieChart: IPieChartData;
      projectChart: IPieChartData;
      groupedProjectsByUser: IPieChartData;
    };
  }> => requests.get(`${USER_URL}/admin-dashboard`),
};
